import { useClassLocationApi } from "../api/ClassLocationApiClient";
import { ClassLocationFrontendService } from "../services/ClassLocationFrontendService";

export const useClassLocationService = (): ClassLocationFrontendService =>
  new ClassLocationFrontendService(useClassLocationApi());
